import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { CriarEntradaDeNotasCompraFormData } from "../schema/criar-entrada-de-notas-compras.schema";
import { EditarEntradaDeNotasCompraFormData } from "../schema/editar-entrada-de-notas-compras.schema";

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/input-invoice/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (query: string, pagina = 0, limite = 10) => {
    try {
        const response = await baseApiService.get(`/input-invoice?page=${pagina + 1}&limit=${limite}&${query}`);
        return response.data.data;
    } catch (error) {
        throw errosHandler(error);
    }
};

const adicionar = async (data: CriarEntradaDeNotasCompraFormData): Promise<void> => {
    try {
        await baseApiService.post('/input-invoice', data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: EditarEntradaDeNotasCompraFormData): Promise<void> => {
    try {
        await baseApiService.put(`/input-invoice/${id}`, data);
    } catch (err) {
        throw errosHandler(err);
    }
};



export const entradaDeNotasCompraService = {
    findAll,
    adicionar,
    detalhar,
    editar
};

